import { getTranslations } from '@assets/i18n/config';
import type { SecurityTableOptions } from '@ovComponents/3-pattern/securitiesSelectionTable/types';
import { workflowTranslation as wc } from '../../workflowTranslations';

const label = (key: string) =>
  wc(['createModelPortfolioWorkflow', 'addSecurities', key]);

/** Column labels and visibility for the Initialize editable allocation table. */
export const getInitializeAllocationTableOptions =
  (): SecurityTableOptions => ({
    securityAllocationChart: {
      columns: [
        {
          security: { enabled: true, label: label('columnSecurityLabel') },
          assetClass: { enabled: true, label: label('columnAssetClassLabel') },
          taxRank: { enabled: true, label: label('columnTaxRankLabel') },
          targetPercentage: {
            enabled: true,
            label: label('columnTargetPercentageLabel'),
          },
          portfolioPercentage: {
            enabled: true,
            label: getTranslations({
              fileName: 'modelPortfolios',
              translationPath: ['securityTableColumns', 'portfolioPercentage'],
            }),
          },
          buttonRemoveSecurity: { enabled: true },
        },
      ],
    },
  });
